"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _SuspenseImage.default;
  }
});
Object.defineProperty(exports, "getSuspenseImageSlots", {
  enumerable: true,
  get: function () {
    return _SuspenseImage.getSuspenseImageSlots;
  }
});
Object.defineProperty(exports, "suspenseImageClasses", {
  enumerable: true,
  get: function () {
    return _suspenseImageClasses.default;
  }
});
var _SuspenseImage = _interopRequireWildcard(require("./SuspenseImage"));
var _suspenseImageClasses = _interopRequireDefault(require("./suspenseImageClasses"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//# sourceMappingURL=index.js.map